export function frontendErrorReference() {
  const random = globalThis.crypto?.randomUUID?.() || Math.random().toString(36);
  return `ERR-UI-${random.replace(/[^a-z0-9]/gi, "").slice(-6).toUpperCase()}`;
}

export function reportFrontendError(error: unknown, reference: string) {
  console.error("Falha não tratada na interface", { reference, error });
}

export function installGlobalErrorHandlers() {
  const onError = (event: ErrorEvent) => {
    reportFrontendError(event.error || event.message, frontendErrorReference());
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    reportFrontendError(event.reason, frontendErrorReference());
  };
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
  return () => {
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onRejection);
  };
}
